import moment from 'moment'

export const ExpenseForm = {
    id: '',
    expensesId: '',
    expensesName: '',
    expensesCategory: '',
    expenseRemarks: '',
    CategoryRemarks: '',
    expensesFormNo: '',
    expensesDate: moment().format('YYYY-MM-DD'),
    price: 0,
    remarks: '',
    supplierId: '',
    supplierName: '',
    uomId: '',
    uomName: '',
    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}